import React, { useMemo } from "react";

import {
  GetExperiencesListResponseBodyType,
  PersonalizationTestType,
} from "@intelligems/ig-types";
import { sortByStatus } from "@intelligems/ig-utils";
import { BaseExperienceTable } from "@src/components/Table/BaseExperienceTable";
import { useSearchOffersData } from "@src/features/sharedExperience/tableUtils";
import { UseQueryResult } from "@tanstack/react-query";

interface ExperiencesTableProps {
  personalizationData: UseQueryResult<
    GetExperiencesListResponseBodyType,
    Error
  >;
  searchInput: string;
  statusFilters: string[];
  typeFilters: PersonalizationTestType[];
}

export const ExperiencesTable = ({
  personalizationData,
  searchInput,
  statusFilters,
  typeFilters,
}: ExperiencesTableProps) => {
  const sortedAndFilteredRowData = useMemo(() => {
    if (!personalizationData.data?.experiencesList) return [];
    return sortByStatus([...personalizationData.data.experiencesList]).sort(
      (a, b) => {
        if (!a || !b || !!a.archivedAtTs === !!b.archivedAtTs) {
          return 0;
        }
        return a.archivedAtTs ? 1 : -1;
      }
    );
  }, [personalizationData.data?.experiencesList]);

  const searchedRowData = useSearchOffersData(
    sortedAndFilteredRowData,
    searchInput,
    typeFilters,
    statusFilters,
    "experiences"
  );

  return (
    <BaseExperienceTable
      renderLocation={"experiences"}
      rowData={searchedRowData}
      isLoading={personalizationData.isLoading}
    />
  );
};
